export default "__VITE_ASSET__CFPQW28O__"